import { render, staticRenderFns } from "./productTransport.vue?vue&type=template&id=40ae6cfa&scoped=true"
import script from "./productTransport.vue?vue&type=script&lang=js"
export * from "./productTransport.vue?vue&type=script&lang=js"
import style0 from "./productTransport.vue?vue&type=style&index=0&id=40ae6cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae6cfa",
  null
  
)

export default component.exports